"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Radium = require("radium");
var context_1 = require("../../context");
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Input.prototype.render = function () {
        var _a = this.props, style = _a.style, className = _a.className, inputClassName = _a.inputClassName, inputStyle = _a.inputStyle, hint = _a.hint, rest = __rest(_a, ["style", "className", "inputClassName", "inputStyle", "hint"]);
        return (React.createElement(context_1.THEME_CONTEXT.Consumer, null, function (theme) {
            var compiledStyles = styles(theme, style, inputStyle);
            return (React.createElement("div", { className: className, style: compiledStyles.container },
                !!hint && React.createElement("label", { style: compiledStyles.hint }, hint),
                React.createElement("input", __assign({}, rest, { className: inputClassName, style: __assign({ boxSizing: 'border-box' }, compiledStyles.input) }))));
        }));
    };
    return Input;
}(React.Component));
var styles = function (theme, style, inputStyle) { return ({
    container: __assign({ display: 'inline-block' }, style),
    input: __assign({ width: '100%', fontSize: theme.common.fontSize, border: theme.input.border, borderRadius: theme.input.borderRadius, padding: theme.input.padding, outline: 'none', background: theme.input.normalBackground, color: theme.input.textColor, 
        //
        ':focus': {
            border: theme.input.borderWidth + "px solid " + theme.input.outlineBorderColor,
        }, 
        //
        ':disabled': {
            background: theme.input.disabledBackground,
            color: theme.input.disabledColor,
        } }, inputStyle),
    hint: {
        display: 'block',
        fontSize: theme.input.labelFontSize,
        marginBottom: '.2rem',
        color: theme.input.textColor,
    },
}); };
exports.default = Radium.default(Input);
